import React from 'react'

import {
  AdminCanUpdateContext,
  IAdminCanUpdateContext,
} from './AdminCanUpdateContext'

export const AdminCanUpdateContextProvider = ({
  children,
  adminCanUpdate,
}: {
  children: React.ReactNode
  adminCanUpdate?: boolean
}) => {
  const context: IAdminCanUpdateContext = {
    adminCanUpdate,
  }

  return (
    <AdminCanUpdateContext.Provider value={context}>
      {children}
    </AdminCanUpdateContext.Provider>
  )
}
